import { useEffect, useRef, useState } from 'preact/hooks';
import Modal from './Modal';
import { getRpc } from '../../utils/initEditorSdk';
import { RPC_CONTEXT } from '@cloudstudio/editor-sdk/lib';
import urlUtils from '../../utils/urlUtils';
import intl from 'react-intl-universal';
const isEmbeddedLoader = urlUtils.isEmbeddedLoader();

export const useModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const cmdServiceRef = useRef();
  useEffect(() => {
    async function init() {
      const rpc = await getRpc();
      cmdServiceRef.current = rpc.getProxy(RPC_CONTEXT.CommandService);
    }
    if (isEmbeddedLoader) {
      init();
    }
  }, []);

  const show = () => setIsVisible(true);
  const hide = () => setIsVisible(false);

  const RenderModal = ({ children, title, okBtn, cancelBtn, hideCancelBtn, onOk, onCancel = hide }) => {
    useEffect(() => {
      (async () => {
        if (isVisible && isEmbeddedLoader && cmdServiceRef.current) {
          onCancel();
          let res;
          if (hideCancelBtn) {
            res = await cmdServiceRef.current.executeCommand('cloudstudio.showDialog', 'info', children, [okBtn]);
          } else {
            res = await cmdServiceRef.current.executeCommand('cloudstudio.confirmDialog', {
              type: 'info',
              message: title,
              detail: children,
              primaryButton: okBtn,
              secondaryButton: cancelBtn,
            });
          }

          if (res.confirmed) {
            onOk();
          }
        }
      })();
    }, [isVisible]);

    return isVisible ? (
      <Modal
        closeModal={hide}
        title={title}
        onOk={onOk}
        onCancel={onCancel}
        okBtn={okBtn}
        cancelBtn={cancelBtn}
        hideCancelBtn={hideCancelBtn}
      >
        {children}
      </Modal>
    ) : null;
  };

  return {
    show,
    hide,
    RenderModal,
  };
};
